/**
 * JBC Collection Redirect
 * =======================
 * Intercepts clicks on collection links site-wide and sends customers to the
 * All Products page with the matching filter pre-applied, so they land on a
 * filtered view rather than a separate collection page.
 *
 * HOW TO INSTALL
 * --------------
 * 1. In Shopify Admin go to: Online Store → Themes → Edit code
 * 2. Under Assets, click "Add a new asset" → paste this file, name it
 *    jbc-collection-redirect.js
 * 3. Open layout/theme.liquid, find </body> near the bottom, and paste
 *    this line just above it:
 *
 *    <script src="{{ 'jbc-collection-redirect.js' | asset_url }}" defer></script>
 *
 * HOW TO CONFIGURE
 * ----------------
 * Edit the two sections marked CONFIGURE below.
 *
 * FINDING YOUR COLLECTION HANDLES
 *   Visit each collection page — the handle is the part after /collections/
 *   in the URL. e.g. jurassicbarkclub.com/collections/leads → handle is "leads"
 *
 * FINDING YOUR FILTER PARAMETER
 *   Go to your All Products page, click a filter option, then look at the URL.
 *   It will contain something like:
 *     ?filter.p.product_type=Leads   ← use 'filter.p.product_type'
 *     ?filter.p.tag=leads            ← use 'filter.p.tag'
 *   Copy the exact parameter name and the exact value for each collection.
 */

(function () {

  /* ============================================================
     CONFIGURE — Part 1: Your All Products collection URL
     ============================================================ */
  var ALL_PRODUCTS = '/collections/all-products';


  /* ============================================================
     CONFIGURE — Part 2: Collection handle → filter value mapping
     ------------------------------------------------------------
     Left side  = collection handle (lowercase, from the URL)
     Right side = filter value (exactly as it appears in the URL
                  when you filter on the All Products page)
     ============================================================ */
  var FILTER_PARAM = 'filter.p.tag';

  var COLLECTION_FILTERS = {
    // handle (from URL)  →  tag value (exactly as it appears after filter.p.tag= in the URL)
    'collars':     'Collars',
    'leads':       'Leads',
    'accessories': 'Accessories',
    'toys':        'Toys',
  };

  /* ============================================================
     ENGINE — no need to edit below this line
     ============================================================ */

  function buildFilteredUrl(filterValue) {
    return ALL_PRODUCTS + '?' + FILTER_PARAM + '=' + encodeURIComponent(filterValue);
  }

  function rewriteLinks() {
    var links = document.querySelectorAll('a[href*="/collections/"]');
    links.forEach(function (link) {
      var href = link.getAttribute('href');

      // Extract the collection handle from the href
      var match = href.match(/\/collections\/([^/?#]+)/);
      if (!match) return;

      var handle = match[1].toLowerCase();

      // Leave the All Products link alone
      if (handle === 'all') return;

      // Check if we have a filter mapping for this handle
      var filterValue = COLLECTION_FILTERS[handle];
      if (!filterValue) return;

      // Rewrite the href
      link.setAttribute('href', buildFilteredUrl(filterValue));
    });
  }

  // Inject a real "ALL PRODUCTS" banner on product pages.
  // Creates a div with the rock texture + a centred link, replacing the
  // CSS ::before banner (which can't hold clickable elements).
  function addProductBannerLink() {
    // URL-based detection is the most reliable
    if (window.location.pathname.indexOf('/products/') === -1) return;

    var mainContent = document.getElementById('MainContent');
    if (!mainContent) return;

    // Don't double-inject
    if (document.getElementById('jbc-product-banner')) return;

    // Mirror the exact DOM structure of the collection hero so all
    // theme styles (page-width padding, font size, colour etc.) apply identically.
    //
    // Collection page structure:
    // <div class="collection-hero color-scheme-5 gradient">
    //   <div class="collection-hero__inner page-width">
    //     <div class="collection-hero__text-wrapper">
    //       <h1 class="collection-hero__title"><a style="...inherit...">All Products</a></h1>
    //     </div>
    //   </div>
    // </div>

    var banner = document.createElement('div');
    banner.id = 'jbc-product-banner';
    // color-scheme-5 brings in the correct text colour automatically
    banner.className = 'collection-hero color-scheme-5 gradient';

    var inner = document.createElement('div');
    inner.className = 'collection-hero__inner page-width';

    var textWrapper = document.createElement('div');
    textWrapper.className = 'collection-hero__text-wrapper';

    var heading = document.createElement('h1');
    heading.className = 'collection-hero__title';

    var link = document.createElement('a');
    link.id = 'jbc-product-banner-link';
    link.href = ALL_PRODUCTS;
    link.textContent = 'All Products';
    link.setAttribute('style', 'color:inherit;text-decoration:none;cursor:pointer;font-family:inherit;font-size:inherit;letter-spacing:inherit;text-transform:inherit;');

    heading.appendChild(link);
    textWrapper.appendChild(heading);
    inner.appendChild(textWrapper);
    banner.appendChild(inner);
    mainContent.insertBefore(banner, mainContent.firstChild);
  }

  // Make the collection banner heading a "clear all filters" link
  // Wraps the .collection-hero__title text in an <a> pointing to the
  // bare All Products URL (no filter params), so clicking it resets everything.
  function makeHeadingClickable() {
    var heading = document.querySelector('.collection-hero__title');
    if (!heading) return;

    // Only act if we're already on the all-products page
    if (window.location.pathname.indexOf('all-products') === -1) return;

    // Don't double-wrap if already a link
    if (heading.querySelector('a')) return;

    var inner = heading.innerHTML;
    heading.innerHTML = '<a href="' + ALL_PRODUCTS + '" style="color:inherit;text-decoration:none;cursor:pointer;font-family:inherit;font-size:inherit;letter-spacing:inherit;text-transform:inherit;">' + inner + '</a>';
  }

  // Inject Kodak film strips into the featured collection cards on the homepage.
  // card__media is absolutely positioned and covers card__inner, so we overlay
  // two absolutely-positioned strip divs (top + bottom) with z-index above the image.
  // Strips extend slightly beyond the card edges for a "trimmed film" look.

  function makeSprocketRow() {
    // A full-width row with sprocket holes on both left and right edges
    var row = document.createElement('div');
    row.className = 'jbc-film-row';
    var left = document.createElement('div');
    left.style.cssText = 'display:flex;gap:5px;';
    var right = document.createElement('div');
    right.style.cssText = 'display:flex;gap:5px;';
    for (var i = 0; i < 5; i++) {
      var h1 = document.createElement('div');
      h1.className = 'jbc-film-sprocket';
      left.appendChild(h1);
      var h2 = document.createElement('div');
      h2.className = 'jbc-film-sprocket';
      right.appendChild(h2);
    }
    row.appendChild(left);
    row.appendChild(right);
    return row;
  }

  function makeFilmStrip(labelText, labelClass) {
    var strip = document.createElement('div');
    strip.className = 'jbc-film-strip';

    // Top sprocket row
    strip.appendChild(makeSprocketRow());

    // Centre label row
    var labelRow = document.createElement('div');
    labelRow.className = 'jbc-film-row jbc-film-row--label';
    var label = document.createElement('span');
    label.className = labelClass;
    label.textContent = labelText;
    labelRow.appendChild(label);
    strip.appendChild(labelRow);

    // Bottom sprocket row
    strip.appendChild(makeSprocketRow());

    return strip;
  }

  function injectFeaturedFilmStrips() {
    var frameNums = ['019B', '031', '044A', '057'];
    var section = document.querySelector('[id*="featured_collection"]');
    if (!section) return;

    var cards = section.querySelectorAll('.card__inner');
    cards.forEach(function(card, i) {
      if (card.querySelector('.jbc-film-strip')) return;

      card.style.overflow = 'visible';

      var top = makeFilmStrip('JBC PROTOTYPE 074', 'jbc-film-label');
      top.style.cssText += 'position:absolute;top:-8px;left:0;right:0;z-index:5;';

      var bot = makeFilmStrip(frameNums[i % frameNums.length] + ' ◄► ' + frameNums[i % frameNums.length], 'jbc-film-framenum');
      bot.style.cssText += 'position:absolute;bottom:-8px;left:0;right:0;z-index:5;';

      card.appendChild(top);
      card.appendChild(bot);
    });
  }

  // Wrap cart item images in a link to their product page.
  // The theme renders images unlinked inside .cart-item__image-container.
  function linkCartImages() {
    var cartItems = document.querySelectorAll('.cart-item');
    cartItems.forEach(function(item) {
      var imgContainer = item.querySelector('.cart-item__image-container');
      if (!imgContainer) return;
      if (imgContainer.parentElement.tagName === 'A') return;

      var productLink = item.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      var a = document.createElement('a');
      a.href = productLink.href;
      a.style.cssText = 'display:block;';
      imgContainer.parentNode.insertBefore(a, imgContainer);
      a.appendChild(imgContainer);
    });
  }

  // Restructure footer copyright: brand name uppercase on top, © year centred below.
  function fixFooterCopyright() {
    var smalls = document.querySelectorAll('.copyright__content');
    smalls.forEach(function(small) {
      var link = small.querySelector('a');
      if (!link || small.textContent.indexOf('©') === -1) return;
      if (small.querySelector('.jbc-footer-brand')) return; // don't double-run

      // Grab the "© 2026" text node that precedes the link
      var textNode = small.childNodes[0];
      var yearText = textNode ? textNode.textContent.trim().replace(/,\s*$/, '') : '';

      small.innerHTML = '';

      var brandDiv = document.createElement('div');
      brandDiv.className = 'jbc-footer-brand';
      brandDiv.appendChild(link);
      small.appendChild(brandDiv);

      if (yearText) {
        var yearDiv = document.createElement('div');
        yearDiv.className = 'jbc-footer-year';
        yearDiv.textContent = yearText;
        small.appendChild(yearDiv);
      }
    });
  }

  // Run once the DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      rewriteLinks();
      makeHeadingClickable();
      addProductBannerLink();
      injectFeaturedFilmStrips();
      linkCartImages();
      fixFooterCopyright();
    });
  } else {
    rewriteLinks();
    makeHeadingClickable();
    addProductBannerLink();
    injectFeaturedFilmStrips();
    linkCartImages();
    fixFooterCopyright();
  }

})();
